import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { dateFormat } from 'utils';
import { profileSelectors } from 'store/profile/selectors';

import { WhiteContainer } from 'containers';

import styles from './styles.module.scss';

const hubURL = process.env.REACT_APP_HUB_URL;

export const DateActiveContainer = () => {
  const { t } = useTranslation('partner');
  const {
    isQualified, dataActive, dataDeActive, referralCode, 
  } = useSelector(
    profileSelectors.getState,
  );
  const link = `${hubURL}/?ref=${referralCode}&self=true`;

  return (
    <div className={styles.partner_container}>
      {/* Case 1: Never activated */}
      {dataActive == null && (
        <WhiteContainer className={styles.partner_content}>
          <div>
            <p className={styles.partner_container_text}>
              {t('Deactivated_account_')}
              <br />
              {t('Note_deactivated_account_')}
            </p>
          </div>
        </WhiteContainer>
      )}

      {/* Case 2: Activated and licensed */}
      {dataActive != null && isQualified && (
        <WhiteContainer className={styles.partner_content}>
          <div className={styles.partner_container_text}>
            {t('Date_active_', { date: dateFormat(dataActive) })}
          </div>
        </WhiteContainer>
      )}

      {/* Case 3: Activation expired */}
      {dataActive != null && !isQualified && (
        <WhiteContainer className={styles.partner_content}>
          <div className={styles.partner_container_text_error}>
            {t('Your_activation_has_expired_')}
          </div>
        </WhiteContainer>
      )}

      {/* Case 4: Deactivation date exists */}
      {isQualified && dataDeActive && (
        <WhiteContainer className={styles.partner_content}>
          <div className={styles.partner_container_text_error}>
            {t('Date_expiration_', { date: dateFormat(dataDeActive) })}
          </div>
        </WhiteContainer>
      )}

      {/* Case 5: Referral link if no deactivation */}
      {(!dataDeActive || !isQualified) && (
        <WhiteContainer className={styles.partner_content}>
          <a
            href={link}
            target="_blank"
            rel="noreferrer"
            className={styles.partner_container_text_underline}
          >
            {t('Referral_code_3_')}
          </a>
        </WhiteContainer>
      )}
    </div>
  );
};
